import { useCallback, useState } from 'react';

export default function useSelectedValue(defaultValue) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const isSelected = useCallback(value => value && value === selectedValue, [selectedValue]);
  return [{ selectedValue, isSelected }, setSelectedValue];
}
